import { Component, OnInit } from '@angular/core';
import { AppSettings } from '../../app.constant';
import { MatSnackBar, MatDialogConfig } from '@angular/material';
import { ProgramService } from 'src/app/shared/services/program.service';
import { ModuleService } from 'src/app/shared/services/module.service';
import { SubjectService } from 'src/app/shared/services/subject.service';
import { FormGroup, FormArray, FormBuilder } from '@angular/forms';
import { Program } from 'src/app/shared/class/program';
import { Module } from 'src/app/shared/class/module';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogboxComponent } from '../../public/dialogbox/dialogbox.component';

@Component({
  selector: 'app-subject',
  templateUrl: './subject.component.html',
  styleUrls: ['./subject.component.css']
})

export class SubjectComponent implements OnInit {
  httpResponseMessage: any;
  subjectForm: FormGroup;
  programs: any;
  errorMessage: any;
  post: any;
  module: any;
  modules: any;
  PK_ProgramID: any;
  Subjects: any;
  SubjectEntities: any;
  data: any;
  status: any;
  selectedProgram: Program = new Program(1, 'ABC', 'asd', 'sadasdsa');
  fileNameDialogRef: MatDialogRef<DialogboxComponent>;

  constructor(
    private formbuilder: FormBuilder,
    private _programservice: ProgramService,
    private _moduleservice: ModuleService,
    private _subjectservice: SubjectService,
    private snackBar: MatSnackBar,
    public dialog: MatDialog) { }

  ngOnInit() {
    this.subjectForm = this.formbuilder.group({
      'FK_ProgramID': [''],
      'FK_ModuleID': [''],
      'SubjectEntities': this.formbuilder.array([])
    })
    //  this.setCompanies();    
    this.getModuleByProgramID(this.selectedProgram.PK_ProgramID);
    this.getAllProgram();
  }

  // core subject
  addnewSubject() {
    let control = <FormArray>this.subjectForm.controls.SubjectEntities;
    control.push(
      this.formbuilder.group({
        PK_SubjectID: [],
        SubjectName: [],
        SubjectCode: [],
        Core_Flag: [],
        Max_Credit: []
      })
    )
  }

  deleteSubject(index) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      title: "Subjects",
      data: index.SubjectName
    };

    this.fileNameDialogRef = this.dialog.open(DialogboxComponent, dialogConfig);
    this.fileNameDialogRef.afterClosed().subscribe(result => {
      this.status = result;
      if (this.status == "ok") {
        let control = <FormArray>this.subjectForm.controls.SubjectEntities;
        var PK_SubjectID = control.value[index].PK_SubjectID
        var o = {
          PK_SubjectID: PK_SubjectID
        }
        this.post = JSON.stringify(o);
        this._subjectservice.deleteSubjectByID(AppSettings.API_ENDPOINT + AppSettings.DeleteSubject, this.post).subscribe(
          data => {
            this.httpResponseMessage = data;
            this.openSnackBar(this.httpResponseMessage, '');
            // this.examForm.reset();
          },
          error => this.errorMessage = <any>error)
        control.removeAt(index);
      }
    })


    // let control = <FormArray>this.subjectForm.controls.SubjectEntities;
    // control.removeAt(index)
  }

  setCompanies() {
    let control = <FormArray>this.subjectForm.controls.SubjectEntities;
    while (control.length !== 0) {
      control.removeAt(0);
    }

    this.data.forEach(x => {
      control.push(this.formbuilder.group({
        PK_SubjectID: x.PK_SubjectID,
        SubjectName: x.SubjectName,
        SubjectCode: x.SubjectCode,
        Core_Flag: x.Core_Flag,
        Max_Credit: x.Max_Credit
      }))
    });
  }

  // get SUBJECTForm() {
  //   return this.subjectForm.get('SubjectEntities') as FormArray
  // }

  // addSubject(){
  //     const SUBJECTfb = this.formbuilder.group({
  //     PK_SubjectID : [],
  //     SubjectName : [],
  //     SubjectCode:[]
  //   })
  //   this.SUBJECTForm.push(SUBJECTfb);
  // }

  // deleteSubject(i){
  //       alert(i);
  //       this.SUBJECTForm.removeAt(i)
  // }

  getAllProgram(): void {
    this._programservice.getAllProgram(AppSettings.API_ENDPOINT + AppSettings.GetAllProgram).subscribe(
      data => {
        this.programs = data;
      },
      error => this.errorMessage = <any>error)
  }

  getModuleByProgramID(PK_ProgramID): void {
    this.PK_ProgramID = PK_ProgramID;
    this._moduleservice.getAllModule(AppSettings.API_ENDPOINT + AppSettings.GetAllModule).subscribe(
      data => {
        this.module = data;
        this.modules = this.module.filter((item) => item.FK_ProgramID == PK_ProgramID);
      },
      error => this.errorMessage = <any>error)
  }

  createSubject(post): void {
    if (this.subjectForm.invalid) { return; }
    this.post = JSON.stringify(post);
    this._subjectservice.postSubject(AppSettings.API_ENDPOINT + AppSettings.CreateSubject, this.post).subscribe(
      data => {
        this.httpResponseMessage = data;
        this.openSnackBar(this.httpResponseMessage, '');
        this.subjectForm.reset();
      },
      error => this.errorMessage = <any>error)
  }

  getSubjectByProgramIDModuleID(PK_ModuleID): void {
    var o = {
      PK_ModuleID: PK_ModuleID,
      FK_ProgramID: this.PK_ProgramID
    }
    this.post = JSON.stringify(o);
    this._subjectservice.getSubjectbyProgramID(AppSettings.API_ENDPOINT + AppSettings.GetSubjectByParam, this.post).subscribe(
      data => {
        this.data = data;
        this.setCompanies();
      },
      error => this.errorMessage = <any>error)
  }


  durationInSeconds = 2;
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
      verticalPosition: 'bottom'
    });
  }
}
